// extracted by mini-css-extract-plugin
export var container = "Checkbox-module--container--QTlnW";
export var input = "Checkbox-module--input--v0XHX";
export var checkmarkBox = "Checkbox-module--checkmarkBox--1KOGe";
export var label = "Checkbox-module--label--ontZo";